/**
 * @author yuanzeyu
 * @date 2020/10/16
 * @desc
 */
import lodash from 'lodash';
import axios from 'axios';
import { LocaleNames } from '../../enum';
import { WalletVcItem } from '../vc/types';
import { jwt2Json } from '../vc/vcSdk';
import Urls from '../../enum/urls';

class DApp {
  public ontId: string = '';

  public scoreResultId: string = ''; // for fetch score result;

  public score: string = '';

  public jwtStr: string = ''; // address list vc jwt string

  public addressList: WalletVcItem[] = [];

  constructor(ontId: string) {
    this.setOntId(ontId);
  }

  private setOntId(ontId: string) {
    this.ontId = ontId;
    localStorage.setItem(LocaleNames.ONT, ontId);
    return this;
  }

  public setJwtStr(jwtStr: string) {
    this.jwtStr = jwtStr;
    localStorage.setItem(LocaleNames.JWT_CACHE_NAME, jwtStr);
    return this;
  }

  public setScoreResultId(id: string) {
    this.scoreResultId = id;
    localStorage.setItem(LocaleNames.SCORE_ID_CACHE, id);
    return this;
  }

  public setScore(score: string) {
    this.score = score;
    localStorage.setItem(LocaleNames.SCORE_CACHE, score);
    return this;
  }

  public clearCache() {
    localStorage.removeItem(LocaleNames.ONT);
    localStorage.removeItem(LocaleNames.JWT_CACHE_NAME);
    localStorage.removeItem(LocaleNames.SCORE_ID_CACHE);
    localStorage.removeItem(LocaleNames.SCORE_CACHE);
    localStorage.removeItem(LocaleNames.LOGIN_TYPE);
    return this;
  }

  static getCacheLoginType(): string {
    return localStorage.getItem(LocaleNames.LOGIN_TYPE) || '';
  }

  /**
   * set or update address list with current jwt string.
   */
  public setAddressListWithJwt() {
    if (!this.jwtStr) {
      this.addressList = [];
      return this;
    }
    const jwtJson = jwt2Json<WalletVcItem[]>(this.jwtStr);
    const addressList = jwtJson.vc.credentialSubject || [];
    this.addressList = lodash.uniqBy(addressList, 'address');
    return this;
  }

  /**
   * fetch score result
   * @param resolve
   * @param reject
   * @protected
   */
  protected async startFetchScore(resolve: (val: any) => any, reject:(val: any) => any) {
    try {
      const { data } = await axios({
        method: 'get',
        baseURL: process.env.REACT_APP_SCAN_URL,
        url: `${Urls.GetQueryScore}/${this.scoreResultId}`,
      });
      const { state } = data.result;
      if (state === 2) {
        const obj = JSON.parse(data.result.oscoreCredential);
        const scoreResult = obj.scoreFromAlg.subject.score;
        resolve(scoreResult);
      } else if (state === 1) {
        setTimeout(() => {
          this.startFetchScore(resolve, reject);
        }, 5000);
      } else {
        reject(data.result.errorInfo || 'Unknown Error.');
      }
    } catch (e) {
      reject(e.message);
    }
  }

  /**
   * fetch score result promise
   * @protected
   */
  protected fetchScorePms(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.startFetchScore(resolve, reject);
    });
  }
}

export default DApp;
